module.exports = __webpack_public_path__ + "static/img/hotWord2.77779c0a.png";